/* eslint-disable quote-props */
module.exports = {
  desktop: {
    'SearchResult': [
      {
        slotName: '/72803759/HelloPeter_D/SearchResult',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['SearchResult-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/SearchResult',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['SearchResult-LB-1']
        }
      }
    ],
    'BestBusiness-Category': [
      {
        slotName: '/72803759/HelloPeter_D/BestBusiness-Category',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['BestBusiness-Category-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BestBusiness-Category',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['BestBusiness-Category-LB-1']
        }
      }
    ],
    'BusinessListing': [
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['BusinessListing-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['BusinessListing-LB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: ['fluid', [300, 250]],
        targetingParams: {
          Pos: ['MPU1'],
          SlotName: ['BusinessListing-MPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: ['fluid', [300, 250]],
        targetingParams: {
          Pos: ['MPU2'],
          SlotName: ['BusinessListing-MPU-2']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: ['fluid', [300, 250], [300, 600]],
        targetingParams: {
          Pos: ['MPU3'],
          SlotName: ['BusinessListing-MPU-3']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/BusinessListing',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB2'],
          SlotName: ['BusinessListing-LB-2']
        }
      }
    ],
    'Home': [
      {
        slotName: '/72803759/HelloPeter_D/Home',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['Home-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Home',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['Home-LB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Home',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB2'],
          SlotName: ['Home-LB-2']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Home',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB3'],
          SlotName: ['Home-LB-3']
        }
      }
    ],
    'Industries-Category': [
      {
        slotName: '/72803759/HelloPeter_D/Industries-Category',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['Industries-Category-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Industries-Category',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['Industries-Category-LB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Industries-Category',
        slotParams: ['fluid', [300, 250]],
        targetingParams: {
          Pos: ['MPU1'],
          SlotName: ['Industries-Category-MPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Industries-Category',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB2'],
          SlotName: ['Industries-Category-LB-2']
        }
      }
    ],
    'IndustryLanding': [
      {
        slotName: '/72803759/HelloPeter_D/IndustryLanding',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['IndustryLanding-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/IndustryLanding',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['IndustryLanding-LB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/IndustryLanding',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB2'],
          SlotName: ['IndustryLanding-LB-2']
        }
      }
    ],
    'MyProfile': [
      {
        slotName: '/72803759/HelloPeter_D/MyProfile',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['MyProfile-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/MyProfile',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['MyProfile-LB-1']
        }
      }
    ],
    'ThankYou': [
      {
        slotName: '/72803759/HelloPeter_D/ThankYou',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['ThankYou-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/ThankYou',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['ThankYou-LB-1']
        }
      }
    ],
    'UserProfile': [
      {
        slotName: '/72803759/HelloPeter_D/UserProfile',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['UserProfile-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/UserProfile',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['UserProfile-LB-1']
        }
      }
    ],
    'Reviewdetail': [
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: [1, 1],
        targetingParams: {
          Pos: ['1x1'],
          SlotName: ['Reviewdetail-1x1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB1'],
          SlotName: ['Reviewdetail-LB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: ['fluid', [300, 250]],
        targetingParams: {
          Pos: ['MPU1'],
          SlotName: ['Reviewdetail-MPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: [[728, 90], 'fluid'],
        targetingParams: {
          Pos: ['LB2'],
          SlotName: ['Reviewdetail-LB-2']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: ['fluid', [300, 250]],
        targetingParams: {
          Pos: ['MPU2'],
          SlotName: ['Reviewdetail-MPU-2']
        }
      },
      {
        slotName: '/72803759/HelloPeter_D/Reviewdetail',
        slotParams: ['fluid', [300, 250], [300, 600]],
        targetingParams: {
          Pos: ['MPU3'],
          SlotName: ['Reviewdetail-MPU-3']
        }
      }
    ]
  },
  mobile: {
    'SearchResult': [
      {
        slotName: '/72803759/HelloPeter_M/SearchResult',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['SearchResult-MMPU-1']
        }
      }
    ],
    'BestBusiness-Category': [
      {
        slotName: '/72803759/HelloPeter_M/BestBusiness-Category',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['BestBusiness-Category-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BestBusiness-Category',
        slotParams: [[320, 50], [320, 100], [300, 250]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['BestBusiness-Category-MMPU-2']
        }
      }
    ],
    'BusinessListing': [
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['BusinessListing-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['BusinessListing-MMPU-2']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU3'],
          SlotName: ['BusinessListing-MMPU-3']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU4'],
          SlotName: ['BusinessListing-MMPU-4']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU4'],
          SlotName: ['BusinessListing-MMPU-5']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU4'],
          SlotName: ['BusinessListing-MMPU-6']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/BusinessListing',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU4'],
          SlotName: ['BusinessListing-MMPU-7']
        }
      }
    ],
    'Home': [
      {
        slotName: '/72803759/HelloPeter_M/Home',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['Home-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/Home',
        slotParams: [[320, 50], [320, 100], [300, 250]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['Home-MMPU-2']
        }
      }
    ],
    'Industries-Category': [
      {
        slotName: '/72803759/HelloPeter_M/Industries-Category',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['Industries-Category-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/Industries-Category',
        slotParams: [[320, 50], [320, 100], [300, 250]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['Industries-Category-MMPU-2']
        }
      }
    ],
    'IndustryLanding': [
      {
        slotName: '/72803759/HelloPeter_M/IndustryLanding',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['IndustryLanding-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/IndustryLanding',
        slotParams: [[320, 50], [320, 100], [300, 250]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['IndustryLanding-MMPU-2']
        }
      }
    ],
    'ThankYou': [
      {
        slotName: '/72803759/HelloPeter_M/ThankYou',
        slotParams: [[320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['ThankYou-MMPU-1']
        }
      }
    ],
    'Reviewdetail': [
      {
        slotName: '/72803759/HelloPeter_M/Reviewdetail',
        slotParams: [[320, 50]],
        targetingParams: {
          Pos: ['MLB1'],
          SlotName: ['Reviewdetail-MLB-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/Reviewdetail',
        slotParams: [[300, 250], [320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU1'],
          SlotName: ['Reviewdetail-MMPU-1']
        }
      },
      {
        slotName: '/72803759/HelloPeter_M/Reviewdetail',
        slotParams: [[300, 250], [320, 50], [320, 100]],
        targetingParams: {
          Pos: ['MMPU2'],
          SlotName: ['Reviewdetail-MMPU-2']
        }
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/misc/ad_config_object.js